// @ts-nocheck

import { v4 } from 'uuid';

import { receive, setPending, set } from '../../actions/betFilter';
import networkActions from '../../actions/network';
import { BetFilterActionTypes } from '../../types/actions/betFilter';
import { NetworkActionTypes } from '../../types/actions/network';
import { type HandlerProps } from '../synchronousMiddleware';

const requests = {};

export const handledActionTypes = [BetFilterActionTypes.ASK_BET_FILTER_ROUTE, NetworkActionTypes.RECV];

const betFilterMiddlewareHandler = ({ store: { dispatch, getState }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    switch (action.type) {
      case BetFilterActionTypes.ASK_BET_FILTER_ROUTE: {
        const { route, betFilterId } = action.payload;
        const sendPayload = { route };
        if (betFilterId) {
          sendPayload.filterId = betFilterId;
        } else {
          const { id: storedBetFilterId } = getState().betFilter;
          if (storedBetFilterId !== null) {
            // if we ask a route without betFilter but one is defined, we reset it
            dispatch(set(null));
          }
        }
        const requestId = v4();
        requests[requestId] = { betFilterId };
        sendPayload.requestId = requestId;
        dispatch(setPending(true));
        dispatch(networkActions.send(sendPayload));
        break;
      }
      case NetworkActionTypes.RECV: {
        const { requestId } = action.payload;
        if (requestId && requests[requestId]) {
          dispatch(receive(requests[requestId].betFilterId || null));
          delete requests[requestId];
        }
        break;
      }
      default:
        break;
    }
  }
};

export default betFilterMiddlewareHandler;
